<template>
  <div class="wrapper">
    <forbidden v-if="forbidden" />
    <slot v-else />
  </div>
</template>

<script>
import Forbidden from '@/components/Forbidden.vue';

export default {
  components: { Forbidden },
  props: {
    forbidden: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
  min-height: 92vh;
  margin-top: 1rem;
  position: relative;
  background: #ffffff;
  border: 1px solid #dde6e9;
  border-radius: 4px;
  box-shadow: 0 60px 60px 0 rgba(0, 0, 0, 0.06);
}
</style>
